import {Routes, Route, BrowserRouter as Router} from 'react-router-dom';
import Home from './components/Home'
import BusinessSingle from './components/BusinessSingle'

function App() {
    const basename = window.$atf_config.basename; 
    return (
        <Router basename={basename}>
            <Routes>
                <Route exact path='/' element={< Home />}/>
                <Route path='/business-single' element={< BusinessSingle />}/>
            </Routes>
        </Router>
    )

}

export default App;
